export default __webpack_public_path__ + "static/media/Sora-Medium.33e6305d.ttf";